/** client routes**/
export const INDEX_ROUTE_PATH = '/';
export const DASHBOARD_ROUTE_PATH = '/dashboard';
export const NOTIFICATION_ROUTE_PATH = '/notification';
export const SINGLE_PROPERTY_DASHBOARD_ROUTE_PATH = '/dashboard/:uuid/:propertyId';

/** Admin routes**/
export const DEFAULT_ADMIN_ROUTE_PATH = '/admin';
export const ADMIN_DASHBOARD_ROUTE_PATH = `${DEFAULT_ADMIN_ROUTE_PATH}/dashboard`;
